/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_RefundInputs */

const en_tx_status_refund = /** @type {(inputs: Tx_Status_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

const id_tx_status_refund = /** @type {(inputs: Tx_Status_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikembalikan`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Tx_Status_RefundInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_refund = /** @type {((inputs?: Tx_Status_RefundInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_RefundInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_refund(inputs)
	return en_tx_status_refund(inputs)
});